import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';

import CloseIcon from './icons/CloseIcon';
import styles from './Sidebar.style';

class SidebarDrawer extends React.Component {
  render() {
    const { classes, children, onClose, ...props } = this.props;

    return (
      <Drawer
        {...props}
        className={classes.modal}
        onClose={onClose}
        width={500}
        anchor="right">
        <IconButton className={classes.close} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        {children}
      </Drawer>
    );
  }
}

SidebarDrawer.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  onClose: PropTypes.func,
};

export default withStyles(styles)(SidebarDrawer);
